// extracted by mini-css-extract-plugin
module.exports = {"modal":"CompanyScenes-modal-7HbXQ"};